import { requireNativeModule } from 'expo-modules-core';
import { Platform } from 'react-native';
const ExpoGooglePay = Platform.select({
    android: () => requireNativeModule('ExpoGooglePay'),
    default: () => null,
})();
export function isSupported() {
    return Platform.OS === 'android' && Platform.Version >= 24;
}
export async function canMakePayments(paymentOptions) {
    try {
        const resultString = await ExpoGooglePay?.canMakePayments(paymentOptions);
        return { result: JSON.parse(resultString) };
    }
    catch (error) {
        return { error };
    }
}
export async function makePaymentRequest(paymentDetails) {
    try {
        // TODO: RN - It is possible that the expo plugin may return strings not objects, we should account for this
        // Depending on the scenario it applies for
        const resultString = await ExpoGooglePay?.makePaymentRequest(paymentDetails);
        return { result: JSON.parse(resultString) };
    }
    catch (error) {
        return { error };
    }
}
export async function makeWorldPayPaymentRequest(paymentDetails) {
    try {
        // TODO: RN - It is possible that the expo plugin may return strings not objects, we should account for this
        // Depending on the scenario it applies for
        const resultString = await ExpoGooglePay?.makeWorldPayPaymentRequest(paymentDetails);
        return { result: JSON.parse(resultString) };
    }
    catch (error) {
        return { error };
    }
}
//# sourceMappingURL=index.js.map